import React from 'react'
import { ModalConfirm } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

export const ModalDelete = ({ show, handleCancel, handleConfirm }) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.Queue.AlertDelRecipientTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.Queue.AlertDelQueue'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
    />
  )
}

ModalDelete.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
